import "./index.scss";
import { DoubleContentBgBlockProps } from "./types";
import {
  getAlignItemsClassNames,
  getJustifyContentClassNames,
} from "utilities/commonPropTypes/flex";
import { getBackgroundClassNames } from "utilities/commonPropTypes/background";
import { getSpacersClassNames } from "utilities/commonPropTypes/spacers";
import { insideBreakpoint, useBreakpoint } from "utilities/BreakpointProvider";
import React from "react";
import classNames from "classnames";

const DoubleContentBgBlock = ({
  alignItems,
  backgroundColor,
  backgroundImage,
  backgroundPosition,
  backgroundSize,
  children,
  imageBgMobile,
  imageBgDesktop,
  imageBgPosition,
  imageBgSize,
  justifyContent,
  marginBottom,
  marginTop,
  paddingBottom,
  paddingTop,
  reverse = false,
}: DoubleContentBgBlockProps) => {
  const breakpoints = useBreakpoint();

  const doubleContentClasses = classNames(
    "DoubleContentBgBlock",
    getSpacersClassNames({
      marginBottom,
      marginTop,
      paddingBottom,
      paddingTop,
    }),
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
  );

  const containerClasses = classNames("wrapContent", "wrapContent-xs-lg");

  const doubleContentStyle = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : {};

  const backgroundClasses = classNames(
    "DoubleContentBgBlock__full-bg",
    getBackgroundClassNames({
      backgroundColor,
      backgroundPosition,
      backgroundSize,
    }),
  );

  const rowBackgroundClasses = classNames(
    "row",
    "no-gutters",
    "DoubleContentBgBlock__bg",
  );

  let blockBackground = {};
  if (insideBreakpoint(breakpoints, ["md"], false) === true && imageBgMobile) {
    blockBackground = { backgroundImage: `url(${imageBgMobile})` };
  } else if (imageBgDesktop) {
    blockBackground = { backgroundImage: `url(${imageBgDesktop})` };
  }

  const colBlockBackgroundClasses = classNames(
    "col-md-6",
    "DoubleContentBgBlock__bg__col",
    {
      "order-md-last": reverse === true,
    },
  );

  const blockImageBackgroundClasses = classNames(
    "DoubleContentBgBlock__bg__image",
    getBackgroundClassNames({
      backgroundPosition: imageBgPosition,
      backgroundSize: imageBgSize,
    }),
  );

  const rowBlockContentClasses = classNames(
    "row",
    "no-gutters",
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
  );

  const colBlockContentClasses = classNames(
    "col-md-6",
    "px-sm",
    "DoubleContentBgBlock__content",
    {
      "order-md-first": reverse === true,
      "DoubleContentBgBlock--reverse": reverse === true,
    },
  );

  return (
    <div className={doubleContentClasses} style={doubleContentStyle}>
      <div className={rowBackgroundClasses}>
        <div className={colBlockBackgroundClasses}>
          <div
            data-testid="imageDiv"
            className={blockImageBackgroundClasses}
            style={blockBackground}
          />
        </div>
        <div className="col-md-6">
          <div className={backgroundClasses} />
        </div>
      </div>
      <div className={containerClasses}>
        <div className={rowBlockContentClasses}>
          <div className="col-md-6" />
          <div className={colBlockContentClasses}>
            <div data-testid="contentWrapper" className={backgroundClasses} />
            <div
              data-testid="childrenContainer"
              className="DoubleContentBgBlock__content__child"
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoubleContentBgBlock;
